import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import APIS from "@service/api";
import { getUser, removeUser } from "@utils";

export const authManagementApi = createApi({
	reducerPath: "authManagementApi",
	refetchOnFocus: false,
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: false,
	baseQuery: fetchBaseQuery({
		baseUrl: APIS["auth-api"],
	}),
	endpoints: (builder) => ({
		reAuth: builder.mutation({
			query: (usernameParam) => {
				const user = getUser();
				const username = (usernameParam || user?.username || "").toLowerCase();

				return {
					url: "/re-auth",
					method: "POST",
					body: { username },
				};
			},
			async onQueryStarted(arg, { queryFulfilled }) {
				try {
					await queryFulfilled;
				} catch (error) {
					const status = error?.error?.status;
					if (status === 400 || status === 401) {
						removeUser();
						window.dispatchEvent(
							new CustomEvent("userLogout", { detail: { sessionExpired: true } })
						);
					}
				}
			},
		}),
		socialLogin: builder.mutation({
			query: (payload) => ({
				url: "/login/social/token",
				method: "POST",
				body: payload,
				credentials: "include",
			}),
		}),
	}),
});

export const { useReAuthMutation, useSocialLoginMutation } = authManagementApi;
